<template>
    <VChart class="chart" v-bind:style="{ height: state.height, width: state.width }" :option="state.selectOption" @click="handleChartClick" />
</template>

<script lang="ts" config>
    import { globalStore, onMounted, reactive, watch } from "@/BaseComponent";

    import { TitleComponent, TooltipComponent, LegendComponent, ToolboxComponent, GridComponent } from "echarts/components";

    import { setOption } from "@/services/commonChartUtils";
    import VChart from "vue-echarts";
    import { CanvasRenderer } from "echarts/renderers";
    import { LineChart, BarChart, PieChart, CandlestickChart } from "echarts/charts";
    import { use } from "echarts/core";

    export default {
        props: {
            title: { type: String },
            subTitle: { type: String },
            titlePadding: { type: Array<number> },
            data: { type: Object },
            legendPosition: { type: String },
            legendContent: { type: String },
            valueContent: { type: String },
            width: { type: String },
            height: { type: String },
        },

        components: {
            VChart,
        },

        setup(props: any) {
            const global = globalStore();
            const state = reactive({
                selectOption: setOption(props),
                height: props.height,
                width: props.width,
            });

            onMounted(() => {
                state.selectOption = setOption(props);
            });

            watch(global, () => {
                state.selectOption = setOption(props);
            });

            use([
                TitleComponent,
                TooltipComponent,
                LegendComponent,
                ToolboxComponent,
                GridComponent,
                CanvasRenderer,
                LineChart,
                BarChart,
                PieChart,
                CandlestickChart,
            ]);

            // 차트 클릭 이벤트 처리...
            const handleChartClick = (params: any) => {
                switch (global.chart) {
                    case "pie":
                    case "donut":
                        alert(params.seriesName + " - " + params.name + " : " + params.value);
                        break;
                    case "test1":
                        alert(params.name + " - " + params.seriesName + " 값1: " + params.value[1] + " 값2: " + params.value[2]);
                        break;
                    default:
                        alert(params.seriesName + " : " + params.data);
                        break;
                }
            };
            return {
                state,
                handleChartClick,
            };
        },
    };
</script>
<style scoped>
    .chart {
        max-width: 100%;
        min-width: 50%;
        height: 400px;
        width: 100%;
    }
</style>
